export const formatPrice = (price: number): string => {
  return new Intl.NumberFormat('fi-FI', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price)
}

export const formatDate = (dateString: string): string => {
  return new Intl.DateTimeFormat('fi-FI', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }).format(new Date(dateString))
}

export const formatDateTime = (dateString: string): string => {
  return new Intl.DateTimeFormat('fi-FI', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(dateString))
}

export const formatShelfNumber = (shelfNumber: string): string => {
  return shelfNumber.toUpperCase()
}

export const calculateTotal = (items: Array<{ määrä: number; yksikköhinta: number }>): number => {
  return items.reduce((total, item) => total + (item.määrä * item.yksikköhinta), 0)
} 